var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(require("../../assets/404.png")),expression:"require(`../../assets/404.png`)"}],attrs:{"alt":""}}),_c('div',[_vm._v("抱歉，暂无页面信息")])])])}
var staticRenderFns = []

export { render, staticRenderFns }